import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropdown from "./Dropdown";
import Radio from "./Radio";
import Tab from "./Tab";
import constants from "../../../utils/constants";

class Filter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      filter,
      selected,
      handleChange,
      handleSelectorChange,
      isTabFiltersCollapsed,
      hasTitle,
    } = this.props;

    if (!filter) {
      return null;
    }

    let FilterElem = null;
    switch (filter.get("representation")) {
      case constants.PROPERTY_FILTER.REPRESENTATION.DROPDOWN:
        FilterElem = Dropdown;
        break;

      case constants.PROPERTY_FILTER.REPRESENTATION.RADIO:
        FilterElem = Radio;
        break;

      case constants.PROPERTY_FILTER.REPRESENTATION.TAB:
        FilterElem = Tab;
        break;

      default:
        break;
    }

    if (!FilterElem) {
      return null;
    }

    return (
      <FilterElem
        filter={filter}
        selected={selected}
        handleChange={typeof handleChange === "function" && handleChange}
        handleSelectorChange={typeof handleChange === "function" && handleSelectorChange}
        isTabFiltersCollapsed={isTabFiltersCollapsed}
        hasTitle={hasTitle}
      />
    );
  }
}

Filter.propTypes = {
  filter: PropTypes.object,
  selected: PropTypes.string,
  handleChange: PropTypes.func,
  handleSelectorChange: PropTypes.func,
  isTabFiltersCollapsed: PropTypes.bool,
  hasTitle: PropTypes.bool,
};

export default Filter;
